import React from 'react'
import {
    Edit,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
    BooleanInput,
    NumberInput,
} from 'react-admin'


export const SistemaElectricoEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <NumberInput source="id" disabled={true}/>
            <TextInput source="name" />
            <TextInput source="subsystem_name" />
            <TextInput source="subsystem_code" />
            <BooleanInput source="active" />
            <ReferenceInput source="sistema_interconectado" reference="sistemas-interconectados">
                <SelectInput source="name" />
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);
